export const calculateScale = (maxVal: number, sliderStops: number) => maxVal / Math.pow(sliderStops, 2.8);

export const calculateValue = (value: number, scale: number) => Math.round(scale * Math.pow(value, 2.8));

export const calculateSliderPos = (value: number, scale: number) => Math.round(Math.pow(value / scale, 1 / 2.8));
